import isString from 'lodash/isString';

const DEFAULT_LOCALE = 'en-US';
const DEFAULT_LANGUAGE_CODE = 'en';
const allowList = [DEFAULT_LOCALE, 'ca-ES', 'es-ES', 'fr-FR', 'fr-CA', 'ja-JP', 'nl-NL', 'de-DE', 'pt-BR', 'pt-PT'];
const languageCodeFallbackMap = {
  [DEFAULT_LANGUAGE_CODE]: DEFAULT_LOCALE,
  ca: 'ca-ES',
  es: 'es-ES',
  ja: 'ja-JP',
  fr: 'fr-FR',
  nl: 'nl-NL',
  de: 'de-DE',
  pt: 'pt-PT',
};
const uniformLanguageTagResolver = 'bcp47';

const languageTagResolver = {
  bcp47: (tag) => {
    const temp = (tag || '').split('_').join('-');
    const parts = temp.split('-');
    switch (parts.length) {
      case 1: // language only
        parts[0] = parts[0].toLowerCase();
        break;
      case 2: // language-script or language-region
        parts[0] = parts[0].toLowerCase();
        if (parts[1].length === 4) { // parts[1] is script
          parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
        } else { // parts[1] is region
          parts[1] = parts[1].toUpperCase();
        }
        break;
      case 3: // language-script-region
        parts[0] = parts[0].toLowerCase();
        parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
        parts[2] = parts[2].toUpperCase();
        break;
      default:
        return temp;
    }

    return parts.join('-');
  },
};

function getFirstBrowserLanguage() {
  const nav = window.navigator;
  const browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
  let i;
  let language;

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(nav.languages)) {
    for (i = 0; i < nav.languages.length; i += 1) {
      language = nav.languages[i];
      if (language && language.length) {
        return language;
      }
    }
  }

  // support for other well known properties in browsers
  for (i = 0; i < browserLanguagePropertyKeys.length; i += 1) {
    language = nav[browserLanguagePropertyKeys[i]];
    if (language && language.length) {
      return language;
    }
  }

  return null;
}

const getBrowserLocale = () => {
  let locale = getFirstBrowserLanguage() || '';
  if (languageTagResolver[uniformLanguageTagResolver]) {
    locale = languageTagResolver[uniformLanguageTagResolver](locale);
  }
  return locale;
};

const getConformingLocale = (locale) => {
  if (!locale || !isString(locale) || locale.length < 2) {
    return DEFAULT_LOCALE;
  }
  if (allowList.includes(locale)) {
    return locale;
  }
  const languageCode = locale.substring(0, 2);
  return languageCodeFallbackMap[languageCode] || DEFAULT_LOCALE;
};

const getLanguageCodeFromLocale = (locale) => {
  if (!locale || !isString(locale) || locale.length < 2) {
    return DEFAULT_LANGUAGE_CODE;
  }
  const langCode = locale.substring(0, 2);
  return Object.keys(languageCodeFallbackMap).includes(langCode) ? langCode : DEFAULT_LANGUAGE_CODE;
};

const getLocale = () => {
  const locale = getBrowserLocale();
  return getConformingLocale(locale);
};

export {
  DEFAULT_LANGUAGE_CODE, DEFAULT_LOCALE, getBrowserLocale, getConformingLocale, getLanguageCodeFromLocale,
};
export default getLocale;
